import { useState, useEffect } from "react";
import RaceWidget from "../../../../../../components/RaceWidget";
import { getPresidentList, getRegions } from "../../../../../api/ph-api";

export const getStaticProps = async () => {
  let presidential = await getPresidentList();
  let regionList = await getRegions();

  // Add candidateColor
  presidential.results.forEach((candidate) => {
    candidate.selected = true;
    candidate.voteCount = "0";
    candidate.votePercentage = 0;
    switch (candidate.last_name.toLowerCase()) {
      case "robredo":
        candidate.color = "rgba(252, 106, 223, 1)";
        candidate.legend = "rect";
        break;
      case "marcos":
        candidate.color = "rgba(192, 36, 2, 1)";
        candidate.legend = "rectRot";
        break;
      case "pacquiao":
        candidate.color = "rgba(57, 198, 240, 1)";
        candidate.legend = "circle";
        break;
      case "domagoso":
        candidate.color = "rgba(64, 118, 255, 1)";
        candidate.legend = "rectRot";
        break;
      case "de guzman":
        candidate.color = "rgba(242, 106, 90, 1)";
        candidate.legend = "rect";
        break;
      case "lacson":
        candidate.color = "rgba(183, 125, 222, 1)";
        candidate.legend = "circle";
        break;
      case "mangondato":
        candidate.color = "rgba(72, 167, 104, 1)";
        candidate.legend = "rect";
        break;
      case "montemayor":
        candidate.color = "rgba(202, 185, 36, 1)";
        candidate.legend = "triangle";
        break;
      case "abella":
        candidate.color = "rgba(92, 161, 144, 1)";
        candidate.legend = "circle";
        break;
      case "gonzales":
        candidate.color = "rgba(197, 101, 12, 1)";
        candidate.legend = "triangle";
        break;
      default:
        candidate.color = "rgba(0, 0, 0, 1)";
        candidate.legend = "circle";
        break;
    }
  });

  return {
    props: { presidential, regionList },
    revalidate: 5,
  };
};

const EmbedPresidentPartialResults = ({ presidential, regionList }) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(
      `${window.location.origin}/elections/2022/races/president-vice-president/results`
    );
  }, []);

  return (
    <RaceWidget
      view={"official-results"}
      withCollapse={false}
      candidatesList={presidential?.results}
      regionList={regionList?.results}
      contestName="presidential race"
      raceName="PRESIDENT PHILIPPINES"
      description="The winner will become the 17th president of the Philippines, to serve for six years starting noon of June 30, 2022. "
      readMoreLink="https://www.rappler.com/nation/elections/president-vp-philippines-powers-duties/"
      quote="Official 2022 presidential and vice presidential election results #PHVote #WeDecide #PHVoteResults"
      urlPath="/elections/2022/candidates/"
      url={url}
      marginTop="marginTop"
      isEmbed="true"
    />
  );
};

export default EmbedPresidentPartialResults;
